import { Slide } from "@mui/material";
import React from "react";

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

export default Transition;
